// import { icons } from 'antd/lib/image/PreviewGroup';
import React, { useEffect, useState, useRef } from "react";
import SmallForm from "../../components/forms/small_form";
import { RESTExecutor, withDomains } from "../../lib/domain";
import { Link } from "react-router-dom";
import moment from "moment";
import "../../../src/index.css";

import "antd/dist/antd.css";
import {
  Form,
  Input,
  Button,
  Checkbox,
  message,
  Row,
  Spin,
  Modal,
} from "antd";
import { LeftOutlined, ReloadOutlined, RightOutlined } from "@ant-design/icons";
import { isDateWithinSevenDays } from "../../util/ui_util";
import { InputOTP } from "antd-input-otp";
import CustomOTPInput from "../../components/CustomOTPInput";
import Fingerprint from "./thumbmark";
import Timer from "./timer";
import { useHistory } from "react-router-dom/cjs/react-router-dom";

const VerificationForm = ({
  userEmail,
  value,
  setValue,
  handleFinish,
  rememberDevice,
  setRememberDevice,
  open,
  handleResendCode,
  auth_resp,
  handleVerify,
  setOpen,
  deviceFingerprint,
  otpRef,
}) => (
  <div>
    <p className="form-header-verify">Verify it's you</p>
    <p className="form-sub-header-verify  ">
      Verification code sent to <span className="primary"> {userEmail}</span>
    </p>
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        width: "100%",
      }}
    >
      <CustomOTPInput
        ref={otpRef}
        length={6}
        value={value}
        onChange={setValue}
        onComplete={handleFinish}
        autoSubmit={true}
        className="otp-input-container"
      />
    </div>
    <Checkbox
      id="normal_login_remember"
      style={{ margin: "10px 0px" }}
      initialValues={{ trust_device: true }}
      checked={rememberDevice}
      onChange={(event) => {
        setRememberDevice(event.target.checked);
      }}
    >
      Trust this Device for 60 days?
    </Checkbox>

    <Timer isActive={open} onResend={handleResendCode} initialSeconds={60} />

    <Button
      loading={auth_resp?.fetching ?? false}
      size="large"
      className="login-form-button-new"
      disabled={!deviceFingerprint}
      style={{
        marginTop: 16,
      }}
      onClick={handleVerify}
    >
      {!deviceFingerprint ? "Preparing..." : "Verify"}
    </Button>

    <div
      onClick={() => {
        setOpen(false);
      }}
      style={{
        textAlign: "center",
        cursor: "pointer",
        marginTop: 8,
      }}
      className="primary"
    >
      Return to Login
    </div>
  </div>
);

const LandingPage = ({ domains, authenticator }) => {
  const history = useHistory();
  const { innerWidth: width } = window;
  const [value, setValue] = useState([]);
  const [open, setOpen] = useState(false);
  const [rememberDevice, setRememberDevice] = useState(true);
  const [deviceFingerprint, setDeviceFingerprint] = useState(null);
  const [userEmail, setUserEmail] = useState("");
  const [activeBlogIndex, setActiveBlogIndex] = useState(0);
  const [blogAnimationDirection, setBlogAnimationDirection] = useState("next");
  const otpRef = useRef(null);
  const [form] = Form.useForm();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [formErrors, setFormErrors] = useState({});
  const blogBackgroundStyle = { backgroundImage: "url('/Login%20Background.png')" };

  let get_blogs = RESTExecutor.list()
    .config({
      label: "getBlogs",
      params: { limit: "2" },
    })
    .callbacks(
      (success) => {
        /* message.success("Email successfully sent");
        setEmailSent(true); */
      },
      (error) => {
        console.error("Login error:", error);
        if (error?.error_message) {
          message.error(error.error_message);
        } else {
          message.error("An unexpected error occurred. Please try again.");
        }
      },
    )
    .connect(domains.blogs);

  let blog_response = get_blogs.response();
  let finalBlogList = blog_response?.result?.items?.sort(
    (a, b) => new Date(b.createdOn) - new Date(a.createdOn),
  );
  const hasBlogs = (finalBlogList?.length || 0) > 0;

  useEffect(() => {
    if (!hasBlogs) {
      setActiveBlogIndex(0);
      return;
    }

    if (activeBlogIndex >= finalBlogList.length) {
      setActiveBlogIndex(0);
    }
  }, [activeBlogIndex, finalBlogList, hasBlogs]);

  const activeBlog = hasBlogs ? finalBlogList[activeBlogIndex] : null;
  const hasMultipleBlogs = hasBlogs && finalBlogList.length > 1;
  const canGoPrev = hasMultipleBlogs && activeBlogIndex > 0;
  const canGoNext = hasMultipleBlogs && activeBlogIndex < finalBlogList.length - 1;

  const handleNextBlog = () => {
    if (!canGoNext) return;
    setBlogAnimationDirection("next");
    setActiveBlogIndex((prevIndex) => prevIndex + 1);
  };

  const handlePrevBlog = () => {
    if (!canGoPrev) return;
    setBlogAnimationDirection("prev");
    setActiveBlogIndex((prevIndex) => prevIndex - 1);
  };

  useEffect(() => {
    get_blogs.execute(true);
  }, []);

  const handleFinish = (otpArray) => {
    if (otpArray && otpArray.length === 6) {
      const otpCode = otpArray.join("");
      if (otpCode.length === 6) {
        handleVerifyWithCode(otpCode);
      }
    }
  };

  const handleVerifyWithCode = (otpCode) => {
    if (!deviceFingerprint) {
      message.error(
        "Device fingerprint not ready. Please try refreshing the page.",
      );
      return;
    }

    const verifyData = {
      otp_code: otpCode,
      user_email: userEmail,
      finger_print: deviceFingerprint,
      trust_device: rememberDevice,
    };

    authenticator.verifyDevice(
      verifyData,
      (success) => {
        if (success) {
          message.success("Login Successful");
          history.push("/");
        }
      },
      (error) => {
        if (error?.error_message) {
          message.error(error.error_message);
        }
        setValue(["", "", "", "", "", ""]);
        setTimeout(() => {
          if (otpRef.current) {
            otpRef.current.focusFirst();
          }
        }, 100);
      },
    );
  };

  const handleVerify = () => {
    const otpCode = Array.isArray(value) ? value.join("") : value;

    if (otpCode.length < 6) {
      //need to fix later by nabin
      /* message.error('Please enter verification code'); */
      return;
    }

    handleVerifyWithCode(otpCode);
  };

  const handleResendCode = () => {
    if (!deviceFingerprint) {
      message.error(
        "Device fingerprint not ready. Please try refreshing the page.",
      );
      return;
    }

    const resendData = {
      email: userEmail,
      finger_print: deviceFingerprint,
    };

    authenticator.resendOtp(
      resendData,
      (success) => {
        success && message.success("Verification code resent successfully");
      },
      (error) => {
        error.error_message && message.error(error.error_message);
      },
    );
  };

  const onFinish = async (values) => {
    setIsSubmitting(true);
    setFormErrors({});

    values.email = values?.email?.trim();
    setUserEmail(values.email);

    if (!deviceFingerprint) {
      message.error(
        "Device fingerprint not ready. Please wait a moment and try again.",
      );
      setIsSubmitting(false);
      return;
    }

    const loginData = {
      ...values,
      finger_print: deviceFingerprint,
    };

    await new Promise((resolve) => {
      authenticator.login(
        loginData,
        (success) => {
          setIsSubmitting(false);

          if (success?.result?.verification_required) {
            setOpen(true);
            resolve(true);
            return;
          }
          if (success?.data?.requires_verification) {
            const rmCheck = document.getElementById("normal_login_remember");
            const emailInput = document.getElementById("normal_login_email");
            if (rmCheck?.checked && emailInput?.value !== "") {
              localStorage.setItem("rememberedEmail", emailInput.value);
              localStorage.setItem("rememberMe", "true");
            } else {
              localStorage.removeItem("rememberedEmail");
              localStorage.removeItem("rememberMe");
            }
            setOpen(true);
          } else if (success) {
            message.success("Login Succesful");
            history.push("/");
          }
          resolve(true);
        },
        (error) => {
          setIsSubmitting(false);
          if (error?.error_message === "requires_verification") {
            setOpen(true);
          } else {
            setOpen(false);
            setFormErrors({ general: error?.error_message });
            error?.error_message && message.error(error.error_message);
          }
          resolve(false);
        },
      );
    });
  };

  let { validation_errors = {}, error_message } = authenticator.response();
  let validateStatus =
    Object.keys(validation_errors || {}).length > 0 ? "error" : "";
  let auth_resp = authenticator.response();

  const LoginForm = () => (
    <div
      style={{
        width: "100%",
        alignSelf: "stretch",
        flexDirection: "column",
        justifyContent: "flex-start",
        alignItems: "flex-start",
        gap: 12,
        display: "flex",
      }}
    >
      <div
        style={{
          alignSelf: "stretch",
          flexDirection: "column",
          justifyContent: "flex-start",
          alignItems: "flex-start",
          gap: 12,
          display: "flex",
        }}
      >
        <div
          style={{
            alignSelf: "stretch",
            justifyContent: "flex-start",
            alignItems: "flex-start",
            gap: 16,
            display: "flex",
          }}
        >
          <div
            style={{
              flex: "1 1 0",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "flex-start",
              gap: 2,
              display: "flex",
            }}
          >
            <div className="login-header-text">
              <span style={{ color: "#343C46" }}>Sign in to </span>
              <span style={{ color: "#143E9F" }}>Tigg</span>
            </div>
            <div className="login-subdomain-text">me.tiggapp.com</div>
          </div>
          <img
            src="images/tigg_logo.png"
            alt="Tigg Logo"
            className="tigg-logo-login"
          />
        </div>

        <div
          style={{
            alignSelf: "stretch",
            flexDirection: "column",
            justifyContent: "flex-start",
            alignItems: "flex-start",
            gap: 10,
            display: "flex",
          }}
        >
          <Form
            form={form}
            name="normal_login"
            className="landing-form"
            size="large"
            initialValues={{
              remember: true,
            }}
            onFinish={onFinish}
            preserve={true}
            style={{
              width: "100%",
            }}
          >
            <div
              style={{
                alignSelf: "stretch",
                flexDirection: "column",
                justifyContent: "flex-start",
                alignItems: "flex-start",
                gap: 12,
                display: "flex",
              }}
            >
              <div
                style={{
                  alignSelf: "stretch",
                  flexDirection: "column",
                  justifyContent: "flex-start",
                  alignItems: "flex-start",
                  gap: 10,
                  display: "flex",
                }}
              >
                <Form.Item
                  name="email"
                  initialValue={localStorage.username}
                  validateStatus={validateStatus}
                  help={(validation_errors?.email ?? [null])[0]}
                  rules={[
                    {
                      required: true,
                      message: "Please input your Username!",
                      validateStatus: "error",
                    },
                  ]}
                  style={{ marginBottom: 0, width: "100%" }}
                >
                  <Input placeholder="yourmail@domain.com" id="normal_login_email" />
                </Form.Item>

                <Form.Item
                  validateTrigger="onSubmit"
                  name="password"
                  initialValue={localStorage.password}
                  validateStatus={validateStatus}
                  help={(validation_errors?.password ?? [null])[0]}
                  rules={[
                    {
                      required: true,
                      message: "Please input your Password!",
                    },
                  ]}
                  style={{ marginBottom: 0, width: "100%" }}
                >
                  <Input.Password
                    placeholder="Enter password"
                    id="normal_login_password"
                  />
                </Form.Item>
              </div>
            </div>

            <div
              style={{
                alignSelf: "stretch",
                flexDirection: "column",
                justifyContent: "flex-start",
                alignItems: "flex-start",
                gap: 14,
                display: "flex",
                marginTop: 10,
              }}
            >
              <div
                style={{
                  alignSelf: "stretch",
                  justifyContent: "flex-start",
                  alignItems: "center",
                  gap: 8,
                  display: "flex",
                }}
              >
                <Link to="/forgot-password" className="forgot-password-link">
                  Forgot Password?
                </Link>
              </div>

              <div
                style={{
                  alignSelf: "stretch",
                  flexDirection: "column",
                  justifyContent: "flex-start",
                  alignItems: "flex-start",
                    gap: 6,
                  display: "flex",
                }}
              >
                <Button
                  loading={isSubmitting}
                  size="large"
                  htmlType="submit"
                  className="login-button-custom"
                  disabled={!deviceFingerprint || isSubmitting}
                  style={{
                    alignSelf: "stretch",
                    paddingLeft: 16,
                    paddingRight: 16,
                    paddingTop: 12,
                    paddingBottom: 12,
                    justifyContent: "center",
                    alignItems: "center",
                    gap: 8,
                    display: "flex",
                    width: "100%",
                  }}
                >
                  {!deviceFingerprint
                    ? "Preparing..."
                    : isSubmitting
                      ? "Logging in..."
                      : "Log in"}
                </Button>
                <div
                  style={{
                    alignSelf: "stretch",
                    overflow: "hidden",
                    borderRadius: 6,
                    justifyContent: "center",
                    alignItems: "center",
                    gap: 8,
                    display: "flex",
                    textAlign: "center",
                    padding: "8px 0",
                  }}
                >
                  <span
                    style={{
                      color: "#343C46",
                      fontSize: 12,
                      fontFamily: "Inter",
                      fontWeight: "500",
                      lineHeight: "18px",
                    }}
                  >
                    Need an account?{" "}
                  </span>
                  <Link to="/register" className="signup-link-text">
                    Sign Up
                  </Link>
                </div>
              </div>
            </div>
          </Form>
        </div>
      </div>
    </div>
  );

  const renderActiveBlogPanel = () => {
    if (!activeBlog) return null;

    const blogUrl = `https://www.tiggapp.com/blog-posts/${activeBlog?.fieldData?.slug}`;
    const allBlogsUrl = "https://www.tiggapp.com/blog";

    return (
      <div className="blog-feature-panel">
        <div
          key={`blog-panel-${activeBlogIndex}`}
          className={
            blogAnimationDirection === "prev"
              ? "blog-panel-animate-prev"
              : "blog-panel-animate-next"
          }
        >
          <div className="blog-feature-content">
            <a href={blogUrl} target="_blank" rel="noopener noreferrer" style={{ display: "block" }}>
              <img
                src={activeBlog?.fieldData?.["main-image"]?.url || "images/logo.svg"}
                alt={activeBlog?.fieldData?.slug || "Blog image"}
                className="blog-feature-image"
              />
            </a>
            <div className="blog-feature-text">
              <div className="blog-feature-date">
                {moment(new Date(activeBlog.createdOn)).format("MMMM D, YYYY")}
              </div>
              <a href={blogUrl} target="_blank" rel="noopener noreferrer" style={{ textDecoration: "none" }}>
                <h3 className="blog-feature-title">{activeBlog?.fieldData?.name}</h3>
              </a>
              <p className="blog-feature-description">
                {activeBlog?.fieldData?.["sub-title-excerpt"]}
              </p>
            </div>
          </div>
        </div>
        <div className="blog-nav-controls">
          <a
            href={blogUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="blog-feature-cta"
          >
            Learn More
          </a>
          <div className="blog-nav-right">
            {!canGoNext && (
              <a
                href={allBlogsUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="blog-view-all-button blog-view-all-link"
              >
                View all blogs
              </a>
            )}
            <button
              type="button"
              className={`blog-nav-button ${canGoPrev ? "blog-nav-button-active" : "blog-nav-button-muted"}`}
              onClick={handlePrevBlog}
              disabled={!canGoPrev}
              aria-label="Previous blog"
            >
              <LeftOutlined />
            </button>
            <button
              type="button"
              className={`blog-nav-button ${canGoNext ? "blog-nav-button-active" : "blog-nav-button-muted"}`}
              onClick={handleNextBlog}
              disabled={!canGoNext}
              aria-label="Next blog"
            >
              <RightOutlined />
            </button>
          </div>
        </div>
      </div>
    );
  };

  return (
    <>
      <Fingerprint setThumbmark={setDeviceFingerprint} />

      <div className="main-container">
        <div className="desktop-layout">
          <div className="left-section-wrapper">
            <div className="blog-background-panel" style={blogBackgroundStyle}>
              <div className="blog-panel-wrapper">
                {blog_response.fetching ? (
                  <div className="blog-loading-container">
                    <Spin />
                  </div>
                ) : activeBlog ? (
                  renderActiveBlogPanel()
                ) : (
                  <div className="no-blog-available">
                    Unable to load the update. Please refresh to try again.
                    <div
                      onClick={() => {
                        get_blogs.execute(true);
                      }}
                    >
                      <ReloadOutlined className="reload-icon" />
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>

          <div className="login-right-container">
            <div className="login-right-scroll-wrapper">
              <div className="login-main-content-desktop">
                <div className="logo-container-desktop">
                  <img
                    src="images/logo2.svg"
                    alt="Tigg Logo"
                    className="logo-responsive"
                  />
                </div>

                <div className="login-form-container">
                  {open ? (
                    <VerificationForm
                      userEmail={userEmail}
                      value={value}
                      setValue={setValue}
                      handleFinish={handleFinish}
                      rememberDevice={rememberDevice}
                      setRememberDevice={setRememberDevice}
                      open={open}
                      handleResendCode={handleResendCode}
                      auth_resp={auth_resp}
                      handleVerify={handleVerify}
                      setOpen={setOpen}
                      deviceFingerprint={deviceFingerprint}
                      otpRef={otpRef}
                    />
                  ) : (
                    <LoginForm />
                  )}
                </div>
              </div>

              <div className="terms-text-container">
                <div className="terms-text">
                  By continuing, you agree to the{" "}
                  <a
                    href="https://www.tiggapp.com/terms-of-use"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <span className="terms-link">Terms of Service</span>
                  </a>
                  , the{" "}
                  <a
                    href="https://www.tiggapp.com/privacy-policy"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <span className="terms-link">Privacy Policy</span>
                  </a>
                  , and other relevant policies of Tigg. For more information,{" "}
                  <a
                    href="https://www.tiggapp.com/contact"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <span className="terms-link">Contact Us</span>.
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="mobile-layout">
          <div className="mobile-login-section">
            <div
              style={{
                padding: 20.17,
                flexDirection: "column",
                justifyContent: "flex-start",
                alignItems: "flex-start",
                gap: 11.53,
                display: "flex",
              }}
            >
              <div
                style={{
                  width: 67.66,
                  height: 67.66,
                  position: "relative",
                }}
              >
                <img
                  src="images/logo2.svg"
                  alt="Tigg Logo"
                  style={{ width: "100%", height: "100%" }}
                />
              </div>
            </div>

            {open ? (
              <VerificationForm
                userEmail={userEmail}
                value={value}
                setValue={setValue}
                handleFinish={handleFinish}
                rememberDevice={rememberDevice}
                setRememberDevice={setRememberDevice}
                open={open}
                handleResendCode={handleResendCode}
                auth_resp={auth_resp}
                handleVerify={handleVerify}
                setOpen={setOpen}
                deviceFingerprint={deviceFingerprint}
                otpRef={otpRef}
              />
            ) : (
              <LoginForm />
            )}

            <div
              style={{
                width: "100%",
                maxWidth: 400,
                paddingLeft: 32,
                paddingRight: 32,
                justifyContent: "center",
                alignItems: "center",
                gap: 8,
                display: "flex",
              }}
            >
              <div className="terms-text">
                By continuing, you agree to the{" "}
                <a
                  href="https://www.tiggapp.com/terms-of-use"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <span className="terms-link">Terms of Service</span>
                </a>
                , the{" "}
                <a
                  href="https://www.tiggapp.com/privacy-policy"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <span className="terms-link">Privacy Policy</span>
                </a>
                , and other relevant policies of Tigg. For more information,{" "}
                <a
                  href="https://www.tiggapp.com/contact"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <span className="terms-link">Contact Us</span>.
                </a>
              </div>
            </div>
          </div>

          <div
            className="mobile-blog-section blog-background-panel"
            style={blogBackgroundStyle}
          >
            <div className="blog-panel-wrapper">
              {blog_response.fetching ? (
                <div className="blog-loading-container">
                  <Spin />
                </div>
              ) : activeBlog ? (
                renderActiveBlogPanel()
              ) : (
                <div className="no-blog-available">
                  Unable to load the update. Please refresh to try again.
                  <div
                    onClick={() => {
                      get_blogs.execute(true);
                    }}
                  >
                    <ReloadOutlined className="reload-icon" />
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default withDomains(LandingPage, "auth", "blogs");
